/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Countriesblacklist2Inputs */

const id_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Hitam Negara`)
};

const ms_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai Hitam Negara`)
};

const da_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landesortliste`)
};

const de_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länder-Sperrliste`)
};

const en_us2_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countries Blacklist`)
};

const es_es2_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista negra de países`)
};

const es_mx2_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista negra de países`)
};

const fil_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blacklist ng mga Bansa`)
};

const fr_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste noire de pays`)
};

const it_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paesi in blacklist`)
};

const hu_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Országok feketelista`)
};

const nl_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landen zwarte lijst`)
};

const no_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land svarteliste`)
};

const pl_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czarna lista krajów`)
};

const pt_br2_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista negra de países`)
};

const pt_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista negra de países`)
};

const ro_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listă neagră țări`)
};

const fi_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maidensisältölista`)
};

const sv_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ländersvartlista`)
};

const vi_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách đen quốc gia`)
};

const tr_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke Kara Listesi`)
};

const cs_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Černá listina zemí`)
};

const bg_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черен списък на държави`)
};

const ru_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чёрный список стран`)
};

const uk_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чорний список країн`)
};

const ar_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القائمة السوداء للدول`)
};

const hi_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देशों की ब्लैकलिस्ट`)
};

const th_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีดำประเทศ`)
};

const ja_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラックリスト国`)
};

const zh_cn2_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国家/地区黑名单`)
};

const zh_hant1_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`國家/地區黑名單`)
};

const ko_offerdetail_table_countriesblacklist2 = /** @type {(inputs: Offerdetail_Table_Countriesblacklist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 블랙리스트`)
};

/**
* | output |
* | --- |
* | "Countries Blacklist" |
*
* @param {Offerdetail_Table_Countriesblacklist2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_countriesblacklist2 = /** @type {((inputs?: Offerdetail_Table_Countriesblacklist2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Countriesblacklist2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "ms") return ms_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "da") return da_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "de") return de_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "fil") return fil_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "fr") return fr_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "it") return it_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "hu") return hu_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "nl") return nl_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "no") return no_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "pl") return pl_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "pt") return pt_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "ro") return ro_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "fi") return fi_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "sv") return sv_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "vi") return vi_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "tr") return tr_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "cs") return cs_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "bg") return bg_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "ru") return ru_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "uk") return uk_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "ar") return ar_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "hi") return hi_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "th") return th_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "ja") return ja_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_countriesblacklist2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_countriesblacklist2(inputs)
	return ko_offerdetail_table_countriesblacklist2(inputs)
});
export { offerdetail_table_countriesblacklist2 as "offerDetail.table.countriesBlacklist" }